import React, { SVGProps } from 'react';

export const EditTranscript = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.067 11.717a2.41 2.41 0 0 1 1.867.897l.488.597c.36.44.578 1.01.578 1.631 0 .771-.334 1.461-.866 1.928l-4.617 4.024c-.37.32-.802.517-1.265.582L10.75 22l1.354-4.474.004-.018c.14-.456.403-.855.752-1.158l4.615-4.023c.427-.38.983-.61 1.592-.61m-.008 1.803a.67.67 0 0 0-.445.17l-4.619 4.024a.74.74 0 0 0-.228.347l-.538 1.78 1.793-.25a.7.7 0 0 0 .355-.16l4.62-4.026a.73.73 0 0 0 .26-.561.73.73 0 0 0-.166-.467l-.491-.6a.68.68 0 0 0-.54-.256M8.25 16.95v1.8H2v-1.8zm3-4.5v1.8H2v-1.8zM15 7.95v1.8H2v-1.8zm3.066-6.325c.036-.166.314-.166.37 0L18.75 2.7c.295 1 1.052 1.76 2.031 2.039l1.071.315a.18.18 0 0 1 .148.185c0 .146-.184.199-.334.24l-.025.007-.024.007-.837.246a2.96 2.96 0 0 0-2.031 2.039l-.314 1.074a.18.18 0 0 1-.185.149c-.146 0-.197-.184-.24-.335l-.014-.05-.245-.838a2.97 2.97 0 0 0-2.032-2.039l-1.071-.315a.18.18 0 0 1-.148-.185c0-.146.184-.198.335-.24l.048-.014.837-.246A2.96 2.96 0 0 0 17.75 2.7z"
    />
  </svg>
);
